var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H19V20H3V15Z",
    fill: "#1A565F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.314V0H10V2.314C8.13346 2.55709 6.41916 3.47109 5.17708 4.88541C3.935 6.29972 3.25002 8.1177 3.25 10V11.75H18.75V10C18.7498 8.11776 18.0647 6.2999 16.8227 4.88563C15.5806 3.47136 13.8665 2.55729 12 2.314Z",
    fill: "#1A565F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15V12.5L11 7L22 12.5V15H20.75V20H22V22H0V20H1.25V15H0ZM3.75 15V20H5.5V15H3.75ZM16.5 15H18.25V20H16.5V15ZM8 15V20H9.75V15H8ZM12.25 15V20H14V15H12.25Z",
    fill: "#78E183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistry);
export default __webpack_public_path__ + "static/media/ministry.6ff1f50847d0e877da85fb491439f0b9.svg";
export { ForwardRef as ReactComponent };